import { LicenseInfo } from '@mui/x-license-pro';

/**
 * NB: API must be updated when it expires (hash bakes in datetime).
 * To update, check if the MUI key is updated in the "Engineering Only" vault (web only)
 * If not, reach out to IT and request for the new key to be added to the vault.
 */
export function setMuiXProLicenseKey() {
  LicenseInfo.setLicenseKey(
    'c0d8f5a8bcac06449f196de7cfbc69a8Tz0xMjIxNjEsRT0xNzk2NjAxNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
  );
}
